export enum ActionTypeE {
  View = 'view',
  Download = 'download',
}
